"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressCheckoutWidgetService = void 0;
const apiRoutes_1 = require("../../utils/apiRoutes");
const Base_1 = require("../Base");
class ExpressCheckoutWidgetService extends Base_1.BaseService {
    fetchWidgetSettings() {
        return this.request({
            url: (0, apiRoutes_1.expressCheckoutWidgetSettingsApiUrl)(),
            method: 'get',
        });
    }
}
exports.ExpressCheckoutWidgetService = ExpressCheckoutWidgetService;
//# sourceMappingURL=index.js.map